// extracted by mini-css-extract-plugin
module.exports = {"expired":"State_expired__RZqwI","active":"State_active__3TPZP","new":"State_new__ecX9V","label":"State_label__1Shnb","iconState":"State_iconState__3ganU"};